import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { ModelControlsPlus, ModelControlsMinus } from './icons';
const ModelControls = ({ 
  onShiftUp, 
  onShiftDown, 
  onShiftLeft, 
  onShiftRight,
  onTurnUp,
  onTurnDown,
  onTurnLeft,
  onTurnRight,
  onZoomInDown,
  onZoomOutDown,
  onShiftStop,
  onTurnStop,
  onZoomStop
}) => {
  return (
    <div
      style={{
        position: 'absolute',
        bottom: '0%',
        right: '0%',
        transform: 'none',
        width: '20vw',
        height: '20vw',
        maxWidth: '250px',
        maxHeight: '250px',
        zIndex: 150
      }}
    >
      {/* Centered container for both button groups */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: '100%'
        }}
      >
        {/* Outer directional (turning) buttons container */}
        <div className="directional-buttons" style={{ transform: 'scale(0.65)', position: 'relative', width: '100%', height: '100%' }}>
          <button 
            className="direction-button up" 
            onMouseDown={onTurnUp}
            onMouseUp={onTurnStop}
            onMouseLeave={onTurnStop}
            onTouchStart={(e) => { e.preventDefault(); onTurnUp(); }}
            onTouchEnd={onTurnStop}
            onTouchCancel={onTurnStop}
            onContextMenu={(e) => e.preventDefault()}
          >
            <span className="visually-hidden">turn up</span>
          </button>
          <button 
            className="direction-button left" 
            onMouseDown={onTurnLeft}
            onMouseUp={onTurnStop}
            onMouseLeave={onTurnStop}
            onTouchStart={(e) => { e.preventDefault(); onTurnLeft(); }}
            onTouchEnd={onTurnStop}
            onTouchCancel={onTurnStop}
            onContextMenu={(e) => e.preventDefault()}
          >
            <span className="visually-hidden">turn left</span>
          </button>
          <button 
            className="direction-button right" 
            onMouseDown={onTurnRight}
            onMouseUp={onTurnStop}
            onMouseLeave={onTurnStop}
            onTouchStart={(e) => { e.preventDefault(); onTurnRight(); }}
            onTouchEnd={onTurnStop}
            onTouchCancel={onTurnStop}
            onContextMenu={(e) => e.preventDefault()}
          >
            <span className="visually-hidden">turn right</span>
          </button>
          <button 
            className="direction-button down" 
            onMouseDown={onTurnDown}
            onMouseUp={onTurnStop}
            onMouseLeave={onTurnStop}
            onTouchStart={(e) => { e.preventDefault(); onTurnDown(); }}
            onTouchEnd={onTurnStop}
            onTouchCancel={onTurnStop}
            onContextMenu={(e) => e.preventDefault()}
          >
            <span className="visually-hidden">turn down</span>
          </button>
          
          {/* Diagonal plus button for zoom in */}
          <button 
            style={{ 
              position: 'absolute', 
              bottom: '5%', 
              right: '5%', 
              width: '45px', 
              height: '45px',
              borderRadius: '50%',
              backgroundColor: '#081F5F',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: 'none',
              cursor: 'pointer',
              fontSize: '20px',
              boxShadow: '0px 4px 10px rgba(0,0,0,0.2)'
            }}
            onMouseDown={onZoomInDown}
            onMouseUp={onZoomStop}
            onMouseLeave={onZoomStop}
            onTouchStart={(e) => { e.preventDefault(); onZoomInDown(); }}
            onTouchEnd={onZoomStop}
            onTouchCancel={onZoomStop}
            onContextMenu={(e) => e.preventDefault()}
          >
            {/* <FontAwesomeIcon icon={faPlus} /> */}
            <ModelControlsPlus/>
            <span className="visually-hidden">zoom in</span>
          </button>

          {/* New minus button for zoom out */}
          <button 
            style={{ 
              position: 'absolute', 
              bottom: '5%', 
              left: '5%', 
              width: '45px', 
              height: '45px',
              borderRadius: '50%',
              backgroundColor: '#081F5F',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: 'none',
              cursor: 'pointer',
              fontSize: '20px',
              boxShadow: '0px 20px 40px rgba(0,0,0,0.2)'
            }}
            onMouseDown={onZoomOutDown}
            onMouseUp={onZoomStop}
            onMouseLeave={onZoomStop}
            onTouchStart={(e) => { e.preventDefault(); onZoomOutDown(); }}
            onTouchEnd={onZoomStop}
            onTouchCancel={onZoomStop}
            onContextMenu={(e) => e.preventDefault()}
          >
            <ModelControlsMinus/>
            <span className="visually-hidden">zoom out</span>
          </button>
        </div>
        
        {/* Inner directional (shifting) buttons container remains unchanged */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none'
          }}
        >
          <div className="directional-buttons" style={{ 
              transform: 'scale(0.3)', 
              backgroundColor: '#e0e0e0', 
              borderRadius: '50%', 
              padding: '10px',
              transformOrigin: 'center center'
          }}>
            <button 
              className="direction-button up" 
              onMouseDown={onShiftUp} 
              onMouseUp={onShiftStop}
              onMouseLeave={onShiftStop}
              onTouchStart={(e) => { e.preventDefault(); onShiftUp(); }}
              onTouchEnd={onShiftStop}
              onTouchCancel={onShiftStop}
              onContextMenu={(e) => e.preventDefault()}
              style={{ pointerEvents: 'auto' }}
            >
              <span className="visually-hidden">shift up</span>
            </button>
            <button 
              className="direction-button left" 
              onMouseDown={onShiftLeft} 
              onMouseUp={onShiftStop}
              onMouseLeave={onShiftStop}
              onTouchStart={(e) => { e.preventDefault(); onShiftLeft(); }}
              onTouchEnd={onShiftStop}
              onTouchCancel={onShiftStop}
              onContextMenu={(e) => e.preventDefault()}
              style={{ pointerEvents: 'auto' }}
            >
              <span className="visually-hidden">shift left</span>
            </button>
            <button 
              className="direction-button right" 
              onMouseDown={onShiftRight} 
              onMouseUp={onShiftStop}
              onMouseLeave={onShiftStop}
              onTouchStart={(e) => { e.preventDefault(); onShiftRight(); }}
              onTouchEnd={onShiftStop}
              onTouchCancel={onShiftStop}
              onContextMenu={(e) => e.preventDefault()}
              style={{ pointerEvents: 'auto' }}
            >
              <span className="visually-hidden">shift right</span>
            </button>
            <button 
              className="direction-button down" 
              onMouseDown={onShiftDown} 
              onMouseUp={onShiftStop}
              onMouseLeave={onShiftStop}
              onTouchStart={(e) => { e.preventDefault(); onShiftDown(); }}
              onTouchEnd={onShiftStop}
              onTouchCancel={onShiftStop}
              onContextMenu={(e) => e.preventDefault()}
              style={{ pointerEvents: 'auto' }}
            >
              <span className="visually-hidden">shift down</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModelControls;